import {useState , useRef , useEffect} from 'react';
import { inputChange, validationByClick , emptyField} from '../../../utils/formValidation';
import Input from '../input/Input';
import Button from '../button/Button';

const FormEditBlog = ({initForm , submitTitle , loading , submit , file , post})=>{

    const [form, setForm] = useState(initForm);

    useEffect(()=>{
        setForm(initForm);
    } , [initForm])

    const formRef = useRef();

    const resetForm = () => {
        setForm(initForm);
    }

    const inputChangeHandler = (e, element) => {
        setForm(inputChange(e, element, form.formItems));
    }

    const emptyFieldHandler = (element) => {
        setForm(emptyField(element , form.formItems));
    }
        

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!loading) {


            let updatedForm = [...form.formItems];
            setForm(validationByClick(form.formItems));

            let allow = true;
            updatedForm.map(item => {
                if (!item.valid) {
                    allow = false;
                    return
                }
            });


            if (allow) {


                    try {

                        if(file){
                            let formData = new FormData(formRef.current);
                            
                            const inputsToExclude = ["faq-q", "faq-a"];
                            inputsToExclude.forEach(name => formData.delete(name));

                            form.formItems.forEach(item => {
                                if (['input-file', 'inputFileUpload'].includes(item.inputType) && !item.file) {
                                    formData.delete(item.config.name);
                                }
                            });

                            // a file input the user left untouched is still sent by the browser
                            // as an empty part, which the api receives as an unexpected text
                            // field (e.g. "images" is not allowed). Drop those entries.
                            Array.from(formData.entries()).forEach(([key, value]) => {
                                if (value instanceof File && (!value.name || value.size === 0)) {
                                    formData.delete(key);
                                }
                            });

                            submit(formData);
                        }else{
                            const newForm = {};
                            for (let item in form.formItems) {
                                newForm[form.formItems[item].config.name] = form.formItems[item].value
                            }
                            submit(newForm);
                        }

                              
                        // const { data } = await replyTicket(router.query.slug , formData);

                        // const status = data.status;

                        // if (status == "success") {
                        //     toast.success(t.new_ticket_successfull);
                        //     let newTicketChilds = [data.ticket , ...ticketChilds] ;
                        //     setTicketChilds(newTicketChilds);
                        //     setForm1(initForm1);
                        // } else if (status == "error") {
                        //     toast.error(t.something_was_wrong);
                        // }
                    
                        //setAllowSend(true);

                    } catch (err) {
                        console.log(err)
                        //showMsg('error', t.something_was_wrong);
                    }   
            }
        }
    }

    return(
        <form onSubmit={(e) => submitHandler(e)} ref={formRef} className={`w-full flex flex-wrap`} >
            {
                form?.formItems?.map((input, index) => {
                    
                    if(input.inputType == 'input-file'){
                    return(
                        <>
                            <Input
                                key={index}
                                inputElement={input.inputType}
                                config={input.config}
                                value={input.value}
                                size={input.size}
                                file={input.file}
                                filename={input.filename}
                                emptyField = {()=>emptyFieldHandler(index)} 
                                change={(e) => inputChangeHandler(e, index)}
                                valid={input.valid}
                                errorMsg={input.errorMsg}
                                used={input.used} />
                                {
                                    post.images &&
                                    <img  src={`${process.env.REACT_APP_S3_ENDPOINT_URL}?${post.images.original}`}/>
                                    
                                }
                        </> 
                    )

                    }else{
                        return(
                            <Input
                            key={index}
                            inputElement={input.inputType}
                            config={input.config}
                            value={input.value}
                            emptyField = {()=>emptyFieldHandler(index)} 
                            change={(e) => inputChangeHandler(e, index)}
                            valid={input.valid}
                            errorMsg={input.errorMsg}
                            used={input.used} />
                        )

                    }
                  
                }
                )
            }
        
            <div className='w-full flex flex-wrap flex-col items-end mb-[16px]'>
                <Button classes="px-4 py-2 bg-primary-100 border border-primary-100 hover:bg-transparent hover:text-primary-100 text-gray-600 font-semibold" loading={loading} click={submitHandler}>
                    {submitTitle}
                </Button>
            </div>
        </form>

    )
 
}

export default FormEditBlog ;